var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8333 15C27.8333 22.0877 22.0877 27.8333 15 27.8333C7.91234 27.8333 2.16666 22.0877 2.16666 15C2.16666 7.91234 7.91234 2.16666 15 2.16666C22.0877 2.16666 27.8333 7.91234 27.8333 15ZM30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM23.2763 8.27633C23.2763 9.13333 22.5816 9.82806 21.7246 9.82806C20.8676 9.82806 20.1729 9.13333 20.1729 8.27633C20.1729 7.41934 20.8676 6.72461 21.7246 6.72461C22.5816 6.72461 23.2763 7.41934 23.2763 8.27633ZM15.164 12.8405L15.354 10.3432L15.5183 8.18279C14.78 8.12663 14.0416 8.19103 13.3312 8.36978C12.7441 8.5175 12.1761 8.74331 11.643 9.0437C10.4647 9.7076 9.50982 10.706 8.899 11.9126C8.28818 13.1192 8.04887 14.4798 8.21134 15.8224C8.37381 17.165 8.93076 18.4293 9.81176 19.4553C10.6928 20.4814 11.8582 21.2232 13.1608 21.5869C14.4634 21.9506 15.8446 21.9198 17.1297 21.4986C18.4148 21.0773 19.5461 20.2844 20.3806 19.2201C20.7582 18.7386 21.0673 18.2113 21.3021 17.6533C21.5862 16.9784 21.7615 16.2585 21.8177 15.5205L21.8178 15.5196L19.6574 15.3553L17.1601 15.1653L14.9997 15.0009L15.164 12.8405ZM18.9617 17.4752L14.8353 17.1614L12.6749 16.997L12.8392 14.8366L13.1531 10.7102C13.0009 10.7757 12.8519 10.8495 12.7066 10.9313C11.9017 11.3849 11.2494 12.0669 10.8321 12.8912C10.4148 13.7154 10.2513 14.6449 10.3623 15.5621C10.4733 16.4793 10.8538 17.343 11.4556 18.0439C12.0575 18.7449 12.8536 19.2516 13.7435 19.5C14.6333 19.7485 15.5768 19.7275 16.4547 19.4397C17.3327 19.1519 18.1055 18.6103 18.6756 17.8832C18.7785 17.752 18.8739 17.6158 18.9617 17.4752Z",
    fill: "url(#paint0_linear_1478_16881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1478_16881",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.90168cc550f4a820bac5a965ff9603fa.svg";
export { ForwardRef as ReactComponent };